import styled, { useTheme } from 'styled-components';

import Accordion from '../../../../ui/Accordion';
import { StyledH3 } from '../../../../ui/Styled';

const StyledIframe = styled.iframe`
  width: 100%;
  height: auto;
  aspect-ratio: 16 / 9; /* Maintain 16:9 aspect ratio */
`;

const FAQs = () => {
  const theme = useTheme();
  const faqs = [
    {
      title: 'About the tariff recommender',
      content: (
        <>
          <p>
            <StyledIframe
              src="https://www.youtube.com/embed/L1xJ9JNnR74?si=JIcQZC_2Jmqo9A5u&rel=0"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            />
          </p>
        </>
      ),
    },
    {
      title: 'Why do we recommend these new tariffs?',
      content: (
        <>
          <p>
            These tariffs are representative of the smart tariff market. They are selected to give you a better
            understanding of what kind of savings can be made by selecting different types of tariffs.
          </p>
          <p>
            This is not an exhaustive list of smart tariffs that are currently available in the market, so there may be
            better deals out there. The tariff recommender is designed to give you a helping hand when trying to select
            the right tariff for you.
          </p>
        </>
      ),
    },
    {
      title: 'Already switched to one of these tariffs?',
      content: (
        <>
          <p>
            If you have already switched tariffs to one of the ones recommended by {theme.language.appName} or found
            another new tariff that works better for you, then you need to let us know. Make your way to the settings
            page and update your current tariff.
          </p>
          <p>
            If you don’t do this you won’t be getting the best out of your new tariff or {theme.language.appName}. So
            when you switch tariffs make sure you let us know!
          </p>
        </>
      ),
    },
    {
      title: 'How do we calculate your ‘annual bill’?',
      content: (
        <>
          <p>
            {theme.language.appName} gathers data from your inverter in a similar way to your smart meter. When we have
            a year's worth of your data we can use this to simulate a few different scenarios for the different tariff
            we have chosen to compare for you. To calculate your ‘annual bill’ we look at when you would have imported
            and exported for each tariff.
          </p>
          <p>
            It’s important to note that this will be slightly different to your actual bill as your supplier is getting
            data from your smart meter and sometimes there can be differences between your smart meter data and your
            inverter data.
          </p>
        </>
      ),
    },
    {
      title: 'How often should I check the tariff recommender?',
      content: (
        <>
          <p>
            The tariff recommender is designed to update every 6 months, for now. As the smart tariff market is
            relatively new and always growing we want the tariff recommender to be useful but not constantly suggesting
            you change your tariff.
          </p>
        </>
      ),
    },
    {
      title: 'How will I know if there’s a better tariff available?',
      content: (
        <>
          <p>
            The tariff recommender is supposed to act as a starting point for your personal tariff selection process. It
            gives you the chance to see what kind of annual bills you could see on different types of tariffs both with{' '}
            {theme.language.appName} and without. Once you have selected the tariff type for you, there could still be
            better tariffs in the market that might serve you better.
          </p>
          <p>
            As an example, the tariff recommender could show that the best tariff for your household is an EV import
            tariff with a flat export rate. While a specific combination of import and export tariffs are shown, there
            may be a slightly better EV import option available that you find in the market.
          </p>
        </>
      ),
    },
    {
      title: 'Are exit fees and switching fees included in the calculations?',
      content: (
        <>
          <p>
            Typically there are no exit or switching fees with smart tariffs. However it is worth noting that there are
            usually clauses preventing you from rejoining a particular tariff within a certain time frame once you
            leave. It is always best to check the supplier's website to confirm what terms and conditions apply to the
            smart tariffs you pick.
          </p>
        </>
      ),
    },
    {
      title: 'Does the tariff recommender consider my green tech system?',
      content: (
        <>
          <p>
            The tariff recommender will use as much of your personal information as it can. {theme.language.appName}{' '}
            needs to know about your solar panels, your battery and your inverter to function. But the tariff
            recommender takes into account other green tech components, such as heat pumps and EV’s.
          </p>
        </>
      ),
    },
    {
      title: 'What Alternative data is being used by the tariff recommender?',
      content: (
        <>
          <p>
            If {theme.language.appName} does not have a full 12 months of your household data then rather than making
            you wait until that data is available, alternative data is used. The alternative data is related to your
            household based on the information you have told us.
          </p>
          <p>
            As soon as {theme.language.appName} has enough data the tariff recommender will use your actual data to
            simulate across the different tariffs.
          </p>
        </>
      ),
    },
  ];

  return (
    <div className="mt-4">
      <StyledH3>FAQs</StyledH3>
      <Accordion data={faqs} />
    </div>
  );
};

export default FAQs;
